import CoreMetadataSearchBlox from './CoreMetadataSearchBlox';

export { type CoreMetadataSearchBloxProps } from './CoreMetadataSearchBlox';
export default CoreMetadataSearchBlox;
